// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'

// Redux:
import { closeMenu } from 'actions/site'
import { getPageData } from 'actions/page'

class Menu extends React.Component {
	constructor( props ) {
		super( props )

		this.menuItems = siteData.site_menu

		if ( props.mobile ) {
			this.menuItems = {
				...this.menuItems,
				...siteData.top_menu
			}
		}
	}

	handleMenuItemClick = () => {
		const { dispatch } = this.props

		dispatch( closeMenu() )
	}

	handleMenuItemMouseOver = ( e ) => {
		// Fails to change page when quickly right after -
		// Sets this to loading, preventing other requests from going through,
		// thus preventing the page from being set after click.

		// const { dispatch } = this.props
		// let slug = e.currentTarget.getAttribute( 'data-id' )

		// if ( slug ) {
		// 	dispatch(
		// 		getPageData( {
		// 			slug: slug,
		// 			requestOnly: true
		// 		} )
		// 	)
		// }
	}

	renderLink( item ) {
		let linkMarkup,
			iconClass = item.icon_class ? item.icon_class : 'list'

		if ( '/' === item.url ) {
			linkMarkup = (
				<NavLink to='/' exact activeClassName="is-active" onClick={ this.handleMenuItemClick }>
					{ item.title }
				</NavLink>
			)
		} else if ( item.url.indexOf( '//' ) > -1 ) {
			linkMarkup = (
				<a href={ item.url } target="_blank" onClick={ this.handleMenuItemClick }>
					{ item.title }
				</a>
			)
		} else {
			linkMarkup = (
				<NavLink
					to={ item.url }
					exact
					activeClassName="is-active"
					onClick={ this.handleMenuItemClick }
					onMouseOver={ this.handleMenuItemMouseOver }
					data-id={ item.url }
				>
					{ item.title }
				</NavLink>
			)
		}

		return linkMarkup
	}

	render() {
		const wrapClass = this.props.menuIsOpen ? 'on-mobile-is-active primary-menu-wrap' : 'primary-menu-wrap'
		var menuItemsMarkup = ''

		if ( this.menuItems && Object.keys( this.menuItems ).length ) {
			menuItemsMarkup = Object.keys( this.menuItems )
				.map( ( key ) => {
					// Top level:

					let e = this.menuItems[ key ],
						childrenMarkup = '',
						linkMarkup = this.renderLink( e )

					if ( e.children && Object.keys( e.children ).length ) {
						// Children:

						let childrenItemsMarkup = Object.keys( e.children )
							.map( ( key ) => {
								let childLinkMarkup = this.renderLink( e.children[ key ] )

								return (
									<li key={ key }>
										{ childLinkMarkup }
									</li>
								)
							})

						childrenMarkup = (
							<div className="-dropdown">
								<ul>
									{ childrenItemsMarkup }
								</ul>
							</div>
						)
					}

					return (
						<li key={ key }>
							{ linkMarkup }
							{ childrenMarkup }
						</li>
					)
				})
		}

		return (
			<div className={ wrapClass }>
				<div className="primary-menu">
					<ul className="-menu">
						{ menuItemsMarkup }
					</ul>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		menuIsOpen: state.site.menuIsOpen,
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( Menu )
